import { CreateFinancialYearAndTransferData } from '../api/createFinancialyear.api';
import { showErrorSnackbar } from '../../../components/snackBar/snakbar';
import { FinancialYearState } from '../types';
import { FinancialYear } from '../../../types';

export const handleCreateFY = async (
  state: FinancialYearState,
  financialYear: FinancialYear,
  setError: (msg: string) => void
): Promise<{ success: boolean; financialYearId?: number }> => {
  try {
    if (financialYear.financialyearid) {
      const response = await CreateFinancialYearAndTransferData({
        aliasname: '',
        companybranchid: 0,
        comments: '',
        startyear: String(state.startYear),
        startdate: state.startDate,
        enddate: state.endDate,
        endyear: String(state.endyear),
        excludedaccountidlist: '',
        excludedaccountgroupidlist: '',
        ledger_transfer_option: 3,
        party_transfer_option: 3,
        item_transfer_option: 3,
        transfer_groups_ledgers: 1,
        ledger_closing_balance: state.transferClosingbalance ? 1 : 0,
        party_closing_balance: state.transferClosingbalance ? 1 : 0,
        from_financialyearid: financialYear.financialyearid,
        to_financialyearid: state.financialYearToId,
      });
      if (!response || !response.statuscode) {
        throw new Error('Invalid response received');
      }
      const { statuscode, statusmessage } = response;
      if (statuscode === 'Error') {
        showErrorSnackbar(statusmessage || 'Unknown error occurred', 'right', 'bottom');
        return { success: false };
      }
      return { success: true, financialYearId: Number(response.financialyearid) };
    }
    return { success: false };
  } catch (error: any) {
    const message = error?.message ?? '';
    if (message.includes('Financial Year Already Created For The StartYear And EndYear')) {
      const snackMsg = 'Financial year already exists';
      const errorMsg = 'Financial year already exists with the selected start and end year. Please choose a different year range.';
      setError(errorMsg);
      showErrorSnackbar(snackMsg, 'right', 'bottom');
    } else if (message.includes('null value in column "transactionid" of relation "transactiondetails" violates not-null constraint')) {
      const snackMsg = 'Invalid financial year selection';
      const errorMsg = 'Please switch to the last created financial year before creating and transferring data to a new financial year. Data transfer is only allowed for consecutive years. Ensure you are in the most recent financial year before proceeding.';
      setError(errorMsg);
      showErrorSnackbar(snackMsg, 'right', 'bottom');
    } else {
      const snackMsg = 'Operation failed';
      const errorMsg = 'Failed to create financial year or transfer accounts. Please check your inputs and try again. If the issue persists, contact support.';
      setError(errorMsg);
      showErrorSnackbar(snackMsg, 'right', 'bottom');
    }
    return { success: false };
  }
};
